import { User, Organization } from "@core/types/core.types";

export type Args = {
  user: User;
  organization: Organization;
  isTokenExpired: boolean;
};

export function useEnrichedAuthUser({
  user,
  organization,
  isTokenExpired,
}: Args) {
  const isAuthenticated = !!user && !isTokenExpired;

  const enrichedUser =
    isAuthenticated && user
      ? {
          id: user.id,
          firebase_uid: user.uid,
          email: user.email,
          organization: organization
            ? { id: organization.id, name: organization.name }
            : null,
          role: user.role,
        }
      : null;

  return {
    user: enrichedUser,
    isAuthenticated,
    rawUser: user,
    rawUserData: user,
    rawOrgData: organization,
  };
}

